"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var builder_1 = require("@react-form-fields/core/config/builder");
var ConfigBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(ConfigBuilder, _super);
    function ConfigBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigBuilder.prototype.setDateConfig = function (locale, format, labels) {
        this.config = tslib_1.__assign({}, this.config, { dateLocale: locale, dateFormat: format, dateLabels: labels });
        return this;
    };
    ConfigBuilder.prototype.setTrumbowygLocale = function (loadLocale) {
        var currentConfig = this.config.trumbowyg || {};
        this.config = tslib_1.__assign({}, this.config, { trumbowyg: tslib_1.__assign({}, currentConfig, { loadLocale: loadLocale }) });
        return this;
    };
    ConfigBuilder.prototype.setTrumbowygPlugins = function (loadPlugins) {
        var currentConfig = this.config.trumbowyg || {};
        this.config = tslib_1.__assign({}, this.config, { trumbowyg: tslib_1.__assign({}, currentConfig, { loadPlugins: loadPlugins }) });
        return this;
    };
    ConfigBuilder.prototype.setTrumbowygConfig = function (config, resetConfig) {
        if (resetConfig === void 0) { resetConfig = false; }
        var currentConfig = this.config.trumbowyg || {};
        this.config = tslib_1.__assign({}, this.config, { trumbowyg: tslib_1.__assign({}, currentConfig, { config: tslib_1.__assign({}, (resetConfig ? {} : (currentConfig.config || {})), config) }) });
        return this;
    };
    ConfigBuilder.prototype.setValidationOn = function (event) {
        this.config = tslib_1.__assign({}, this.config, { validationOn: event });
        return this;
    };
    return ConfigBuilder;
}(builder_1.default));
exports.default = ConfigBuilder;
//# sourceMappingURL=builder.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/config/builder.js
// module id = 682
// module chunks = 58